import {
  FirebaseAuthService,
  logout as reduxLogout,
  reset,
  useMutate,
} from '@kanda-libs/ks-frontend-services';
import { URLS } from 'config';
import { useAppDispatch } from 'hooks';
import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export type LogoutHook = (redirect?: boolean) => Promise<void>;

export function useLogout(automaticallyLogout = true): LogoutHook {
  const { push } = useHistory();
  const { mutate: logout } = useMutate(FirebaseAuthService.logout);
  const dispatch = useAppDispatch();

  const handleLogout = useCallback(
    (redirect = true, url = URLS.home) =>
      new Promise<void>((resolve) => {
        logout(false).then(() => {
          dispatch(reduxLogout());
          dispatch(reset());
          if (redirect) push(url);
          resolve();
        });
      }),
    [logout, push, dispatch],
  );

  useEffect(() => {
    if (!automaticallyLogout) return;
    handleLogout();
  }, [handleLogout, automaticallyLogout]);

  return handleLogout;
}
